import BottomSectionA from 'containers/Learn/Articles/BottomSectionA';
import LeftSectionA from 'containers/Learn/Articles/LeftSectionA';
import RightSectionA from 'containers/Learn/Articles/RightSectionA';
import SectionLayout from 'containers/Learn/Articles/SectionLayout';
import TopSectionA from 'containers/Learn/Articles/TopSectionA';
import { IGeneralSection } from 'interfaces/IMarketing';
import { HEADER_SIZE } from './utils/getHeader.util';

interface ILayoutAProps {
  articles: IGeneralSection[];
  highestHeadingSize?: HEADER_SIZE;
  isArticle?: boolean;
}

const LayoutA = ({
  articles,
  highestHeadingSize = HEADER_SIZE.H1,
  isArticle,
}: ILayoutAProps) => (
  <div>
    {articles.map((article) => {
      switch (article.layout) {
        case SectionLayout.Right:
          return (
            <RightSectionA
              key={article.id}
              article={article}
              highestHeadingSize={highestHeadingSize}
            />
          );
        case SectionLayout.Left:
          return (
            <LeftSectionA
              key={article.id}
              article={article}
              isArticle={isArticle}
              highestHeadingSize={highestHeadingSize}
            />
          );
        case SectionLayout.Top:
          return (
            <TopSectionA
              key={article.id}
              article={article}
              highestHeadingSize={highestHeadingSize}
            />
          );
        case SectionLayout.Bottom:
        default:
          return <BottomSectionA key={article.id} article={article} />;
      }
    })}
  </div>
);

export default LayoutA;
